
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoyInstallationMooring as ObiSimplifiedBuoyInstallationMooringElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-installation-mooring.js';
 
 
 

 
 export const ObiSimplifiedBuoyInstallationMooring = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-installation-mooring',
   elementClass: ObiSimplifiedBuoyInstallationMooringElement,
   events: {
     
   }
  });
 
 